export default {
  title: 'Think Academy\'s Free Math Workbooks',
  subTitle: 'Try our free math learning materials for different grades produced by the content development team of Think Academy. For each grade, there are workbooks of different levels. Search for your child\'s grade, download and then print workbooks to practice at home.',
  form: {
    title: 'Need more accurate assessment on math?',
    subTitle: 'We also provide 1 on 1 evaluation, monthly practice, competition practices, and mock exams, for FREE!',
    submitBtn: 'Contact Me',
    tip: 'By clicking "Contact Me" you explicitly agree to Think Academy US emailing you free learning resources and offers about our other services. You can unsubscribe at any time.',
    leadText: 'Or contact us on WhatsApp or Wechat.',
    leadBtn: '',
    toolsList: ['wechat', 'whatsapp'],
  },
}
